import React from 'react';
import { VimeoVideo } from '@components/VimeoVideo';
import { ValuePropsArg, ValuePropsSection } from '@components/ValuePropsSection';
import {
  HeroVideoContainer,
  HeroVideoWrapper,
  HeroVideoOverlay,
  StyledSection,
  DisplayOnMobile,
  DisplayAboveMobile,
  HeroTextColumn,
  HeroTextPairing,
} from './HeroSectionWithProps.styles';
import { Columns } from '@components/Columns';
import { Flex } from '@components/Flex';

export const HeroSectionWithProps: React.FC<{
  sectionId: string;
  heroData: { posterUrl: string; videoUrl: string; title: string; eyebrow: string };
  valueProps: ValuePropsArg[];
  valuePropsMobile: ValuePropsArg[];
  valuePropsElementId: string;
}> = ({ sectionId, heroData, valueProps, valuePropsMobile, valuePropsElementId }) => {
  const { posterUrl, videoUrl, title, eyebrow } = heroData;
  return (
    <>
      <StyledSection as="section" id={sectionId}>
        <HeroVideoContainer>
          <HeroVideoWrapper>
            <HeroVideoOverlay />
            <VimeoVideo
              posterUrl={posterUrl}
              isEagerLoading
              embedUrl={videoUrl}
              title={title}
              autoPlay
              background
              controls={false}
              autoPause={false}
              alt={title}
              muted
              loop
              cover
              posterOptimization="aggressive"
            />
          </HeroVideoWrapper>
        </HeroVideoContainer>
        <HeroTextColumn verticalAlign="end">
          <Columns.Column width={12}>
            <Flex flexDirection={'column'} alignItems="center">
              <HeroTextPairing
                title={title}
                titleVariant="hed72Hero"
                titleColor="mono7"
                titleTagName="h1"
                alignment="center"
                eyebrow={eyebrow}
                eyebrowColor="mono7"
                eyebrowVariant="sectionEyeBrow20"
              />
            </Flex>
          </Columns.Column>
        </HeroTextColumn>
      </StyledSection>
      <DisplayAboveMobile>
        <ValuePropsSection values={valueProps} elementId={valuePropsElementId} maxWidth="1032px" />
      </DisplayAboveMobile>
      <DisplayOnMobile>
        <ValuePropsSection values={valuePropsMobile} elementId={valuePropsElementId} />
      </DisplayOnMobile>
    </>
  );
};
